<div class="contract-row-card card-wrapper">
    <div class="card">
        @if ((appFacadeService.isLineItemCalledOff(itemOut.id) | async) === false) {
        <ng-template porFeatureAvailability [featureToken]="['Account.RequestCallOff', 'Account.RequestService']">
            <div class="head-top">
                <div class="checkbox">
                    <por-base-checkbox #check [isChecked]="params.value" (checkboxChange)="checkedHandler($event)" [isDisabled]="isDisabled"></por-base-checkbox>
                </div>
            </div>
        </ng-template>
        }
        <ul>
            @for (item of itemOutKV; track item) {
            <li class="row">
                <div class="col-2">
                    <h5 class="title">{{ item.label | translate }}</h5>
                </div>
                <span>:</span>
                <div class="col-10">
                    @if (item.label !== 'itemName') {
                    <data>
                        {{ item.value }}
                    </data>
                    } @else {
                    <data class="special-span" [innerHTML]="item.value | formLineItemName"></data>
                    }
                </div>
            </li>
            }
        </ul>

        <ng-template porFeatureAvailability [featureToken]="['Account.RequestCallOff', 'Account.RequestService']">
            <por-base-button (onclick)="loadRequestmodal()" [featureName]="'item-out-requests-button'">{{ 'Requests' | translate }}</por-base-button>
        </ng-template>
    </div>
</div>
